import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from '../../ui';
import sessionsService from '../../../services/sessionsServices';
import Toast from '../../Toast';

/**
 * Delete Chat confirm modal.
 * API unchanged: sessionsService.deleteSession
 */
const DeleteChatModal = ({ onClose, data }) => {
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.deleteSession({
        platform_id: 'splylabs',
        session_id: data?.id,
        user_id: '123',
        project_id: 'test',
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      onClose();
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <ConfirmModal
      title="Delete Chat"
      message={<p>Are you sure you want to delete this chat? There is no way to recover it.</p>}
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={handleSubmit.isPending}
      onConfirm={() => handleSubmit.mutate()}
      onClose={onClose}
    />
  );
};

export default DeleteChatModal;
